import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ListPagerComponent } from '../../components/list-pager/list-pager.component';
import { TableBookingsComponent } from '../../components/table-bookings/table-bookings.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import UrlUtil from '../../utils/url-util.service';
import BookingsService from '../../services/bookings.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import moment from 'moment';
import { Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'card-bookings',
	templateUrl: './card-bookings.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, ListPagerComponent, TableBookingsComponent, FormsModule ]
})
export class CardBookingsComponent implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private urlUtil: UrlUtil = inject(UrlUtil);
	private bookingsService: BookingsService = inject(BookingsService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private router: Router = inject(Router);
	
	@Input() tabs: any;
	@Input() dateRangeModel: any | undefined;
	@Input() nameFilter: any | undefined;
	@Input() bookingStatusFilter: any | undefined;
	@Input() activeTab: any | undefined;
	
	vm: any = undefined;
	navigationSubscription: Subscription = undefined;
	watcher: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.bookings = [];
		this.vm.pageSize = 10;
		this.vm.user = this.session.getSession().user;
		this.vm.isDoctor = this.vm.user.businessUserType === 'SERVICE_PROVIDER';
		this.vm.currentPage = 0;
		this.vm.endReached = false;
		this.vm.loading = true;
		this.vm.activeTab = this.vm.activeTab || {};
		this.getActiveTab();
		if (this.vm.dateRangeModel && this.vm.dateRangeModel.start && this.vm.dateRangeModel.end) {
			this.vm.createdStart = moment(this.vm.dateRangeModel.start).format('YYYYMMDD');
			this.vm.createdEnd = moment(this.vm.dateRangeModel.end).format('YYYYMMDD');
		}
		this.loadBookings(true);
		
		var currentPayedBookings = 0;
		var currentConfirmedBookings = 0;
		this.watcher = this.angularHelperService.createInterval(() => {
			var newPayedCount = this.bookingsService.getBookings('PAYED').length;
			var newConfirmedCount = this.bookingsService.getBookings('CONFIRMED').length;
			
			if (currentPayedBookings !== newPayedCount) {
				currentPayedBookings = newPayedCount;
				if (this.vm.activeTab.status === 'PAYED') this.initBookings(this.bookingsService.getBookings('PAYED'), true);
			}
			if (currentConfirmedBookings !== newConfirmedCount) {
				currentConfirmedBookings = newConfirmedCount;
				if (this.vm.activeTab.status === 'CONFIRMED') this.initBookings(this.bookingsService.getBookings('CONFIRMED'), true);
			}
		}, 500);
		
		var currentDateRangeFilter = undefined;
		var currentStatusFilter = undefined;
		var currentNameFilter = undefined;
		this.vm.filterCheckInterval = this.angularHelperService.createInterval(() => {
			var newStatusFilter = this.vm.bookingStatusFilter;
			if (newStatusFilter != currentStatusFilter) {
				currentStatusFilter = newStatusFilter;
				this.vm.currentPage = 0;
				this.loadBookings(true);
			}
			
			var newNameFilter = this.vm.nameFilter;
			if (newNameFilter != currentNameFilter) {
				currentNameFilter = newNameFilter;
				this.vm.currentPage = 0;
				this.loadBookings(true);
			}
			
			var newDateRange = this.vm.dateRangeModel;
			if ((currentDateRangeFilter == undefined && newDateRange != undefined) || (newDateRange != undefined && newDateRange.start
				&& (currentDateRangeFilter.start != newDateRange.start || currentDateRangeFilter.end != newDateRange.end))) {
				currentDateRangeFilter = newDateRange;
				var newCreatedStart: any = moment(newDateRange.start).format('YYYYMMDD');
				var newCreatedEnd: any = moment(newDateRange.end).format('YYYYMMDD');
				if (newCreatedStart != this.vm.createdStart || newCreatedEnd != this.vm.createdEnd) {
					this.vm.createdStart = newCreatedStart;
					this.vm.createdEnd = newCreatedEnd;
					this.vm.currentPage = 0;
					this.loadBookings(true);
				}
			}
		}, 200);

		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(
				this, this.config.getBroadcastConfig().Bookings.REINITIALIZE, () => {
					this.vm.currentPage = 0;
					this.loadBookings(true);
				})
		);
		
		this.navigationSubscription = this.router.events.subscribe(
			(event: any) => {
				if (event instanceof NavigationEnd) {
					this.getActiveTab();
					if (this.vm.activeTab.href !== 'history') {
						this.vm.createdStart = undefined;
						this.vm.createdEnd = undefined;
					}
					this.vm.currentPage = 0;
					this.loadBookings(true);
				}
			}
		);
	}
	
	ngOnDestroy() {
		if (this.navigationSubscription) {
			this.navigationSubscription.unsubscribe();
		}
		if (this.vm.filterCheckInterval) {
			this.angularHelperService.cancelInterval(this.vm.filterCheckInterval);
		}
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	currentPageChanged(newPage) {
		this.vm.currentPage = newPage;
		this.loadBookings();
	}
	
	getActiveTab() {
		var type: any = this.angularRoutingHelperService.getRouteParam('type');
		if (!type || !this.vm.tabs || !this.vm.tabs.length) return;
		this.vm.tabs.map((item, index) => {
			if (item.href.split('/').pop() === type) {
				this.vm.activeTab = item;
			}
		});
	}
	
	loadBookings(isInitial?) {
		if (isInitial) {
			this.vm.endReached = false;
		} else if (this.vm.endReached) {
			this.vm.loading = false;
			return;
		}
		if (this.vm.activeTab.status === 'PAYED') {
			var bookings: any = this.bookingsService.getBookings('PAYED');
			this.initBookings(bookings, isInitial);
		} else {
			var requestedStatus: any = this.vm.activeTab.status;
			if (this.vm.activeTab.status === 'CONFIRMED') {
				if (this.vm.isDoctor) {
					requestedStatus = this.vm.activeTab.status;
				} else {
					requestedStatus = 'UPCOMING';
				}
			} else {
				if (this.vm.bookingStatusFilter && this.vm.bookingStatusFilter !== 'ALL') {
					requestedStatus = this.vm.bookingStatusFilter ? this.vm.bookingStatusFilter : null;
				}
			}
			
			var params = {
				pageSize: this.vm.pageSize * 2,
				start: (!isInitial && this.vm.bookings) ? this.vm.bookings.length : 0
			};
			if (requestedStatus) {
				params['status'] = requestedStatus;
			}
			if (!this.vm.activeTab.status) {
				params['orderBy'] = 'start';
			}
			if (this.vm.nameFilter) {
				params['name'] = this.vm.nameFilter;
			}
			if (this.vm.createdStart) {
				params['startDate'] = this.vm.createdStart;
			}
			if (this.vm.createdEnd) {
				params['endDate'] = this.vm.createdEnd;
			}
			
			this.bookingsService.fetchBookings(params).then((bookings) => {
				if (bookings && bookings.length < this.vm.pageSize * 2) {
					this.vm.endReached = true;
				}
				this.initBookings(bookings, isInitial);
			});
		}
	}
	
	initBookings(bookings, isInitial) {
		bookings.map((booking) => {
			booking.closeInfo = () => {
				booking.isOpen = false;
			};
		});
		this.vm.bookings = isInitial ? bookings : this.vm.bookings.concat(bookings);
		this.angularHelperService.createTimer(() => {
			this.vm.loading = false;
			this.angularBroadcastHelperService.rootBroadcast(this.config.getBroadcastConfig().Bookings.INITIALIZED,
				{ origin: 'components/card-bookings ' });
		}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
	}
	
}